import React from 'react';
import styles from '../pages/HomePage.module.css';
import '../styles/buttons.css';
import { COLORS } from '../constants';

export interface QuestData {
  id: string;
  title: string;
  description: string;
  reward: number;
  isStarted: boolean;
  timeRemaining?: number;
  progressPercentage: number;
  showTimer?: boolean;
  actionButtonText: string;
  actionButtonColor: string;
  onStart: () => void;
  onAction: () => void;
}

interface QuestProps {
  quest: QuestData;
  formatTime?: (seconds: number) => string;
}

const Quest: React.FC<QuestProps> = ({ quest, formatTime }) => {
  const {
    title,
    description,
    reward,
    isStarted,
    timeRemaining,
    progressPercentage,
    showTimer = true,
    actionButtonText,
    actionButtonColor,
    onStart,
    onAction
  } = quest;

  const getButtonClass = (color: string) => {
    switch (color) {
      case COLORS.DANGER:
        return 'btn btn-danger';
      case COLORS.SUCCESS:
        return 'btn btn-success';
      case COLORS.PRIMARY:
        return 'btn btn-primary';
      default:
        return 'btn';
    }
  };

  return (
    <div className={`${styles.questCard} ${styles.questInProgress}`}>
      <div className={styles.questHeader}>
        <span className={styles.questTitle}>{title}</span>
        <span className={styles.questReward}>
          Reward: {reward} <span className={styles.heart}>❤️</span>
        </span>
      </div>
      <div className={styles.questDescription}>{description}</div>
      <div className={styles.questProgressBarWrapper}>
        <div className={styles.questProgressBar}>
          <div 
            className={styles.questProgress} 
            style={{ width: `${progressPercentage}%` }} 
          />
        </div>
        <span className={styles.questProgressPercent}>
          {Math.round(progressPercentage)}%
        </span>
      </div>
      {isStarted ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0.5rem' }}>
          <div className={styles.questStatusInProgress}>In Progress</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {showTimer && timeRemaining !== undefined && formatTime && (
              <span style={{ fontFamily: 'monospace', fontSize: '1.1rem', fontWeight: 'bold', color: COLORS.BLUE }}>
                {formatTime(timeRemaining)}
              </span>
            )}
            <button 
              onClick={onAction}
              className={getButtonClass(actionButtonColor)}
              style={{ backgroundColor: actionButtonColor }}
            >
              {actionButtonText}
            </button>
          </div>
        </div>
      ) : (
        <button 
          onClick={onStart}
          className={styles.navLink}
          style={{ marginTop: '0.5rem' }}
        >
          Start
        </button>
      )}
    </div>
  );
};

export default Quest; 